import { mergeFilters, toggleReduxSliceFiltersVisibility } from "@helpers/reduxHelpers.js";
import { createSlice } from "@reduxjs/toolkit";
import FILTERS_KEYS from "@utils/filters_keys.js";
import { REHYDRATE } from "redux-persist/es/constants";

const defaultFilters = [
	{ id: FILTERS_KEYS.requestsManagement.devices, name: "requests:devicesFilter", visible: false },
	{ id: FILTERS_KEYS.requestsManagement.vessels, name: "requests:vesselsFilter", visible: false },
	{ id: FILTERS_KEYS.requestsManagement.status, name: "requests:statusFilter", visible: false },
	{ id: FILTERS_KEYS.requestsManagement.date, name: "requests:dateFilter", visible: false },
];
const initialState = {
	data: [],
	filters: [],
	page: 1,
	perPage: 10,
	totalItems: 0,
	totalPage: 0,
	loading: false,
};

const requestsSlice = createSlice({
	name: "auth/user",
	initialState,
	reducers: {
		setLoadingRequests: (state, action) => {
			state.loading = action.payload;
		},
		setRequestsData: (state, action) => {
			const { data, totalItems, page, perPage } = action.payload;

			state.data = data || [];
			state.totalItems = totalItems || 0;
			state.page = page || 1;
			state.perPage = perPage || 10;
			state.totalPage = Math.ceil(totalItems / perPage);
		},
		toggleRequestsFilterVisibility: toggleReduxSliceFiltersVisibility,
	},
	extraReducers: (builder) => {
		builder.addCase(REHYDRATE, (state, action) => {
			// Get persisted filters
			const persistedFilters = action.payload?.modules?.accountManagement.requests?.filters ?? null;
			// Merge filters with persisted state
			state.filters = mergeFilters(persistedFilters, defaultFilters);
		});
	},
});

export const { setLoadingRequests, setRequestsData, toggleRequestsFilterVisibility } =
	requestsSlice.actions;
export default requestsSlice.reducer;
